<form #form="ngForm">
    <div class="app-grid">
        <h3>{{ 'benefits.components.change-request-approval.submitResponse' | appTranslate }}</h3>
        <div class="margin-top-1 margin-bottom-2">
            {{ 'benefits.components.change-request-approval.approvalNotes' | appTranslate }}
        </div>
        <mat-form-field class="columns-12">
            <mat-label> {{ 'benefits.components.change-request-approval.addNote' | appTranslate }} </mat-label>
            <textarea matInput [(ngModel)]="changeRequest.adminNotes" name="adminNotes" style="height: 90px"></textarea>
        </mat-form-field>
    </div>
</form>
